<template>
    <div class="comments clearfix">
        <div class="comments__top">
            <h4 class="comments__title txt--white">
                {{ texts.reactions_main_title }} 
                <sup>({{ comments.length }})</sup>
            </h4>
            <span @click="writeComment()" v-if="commentState == 0" class="comments__add btn-ghost--white">Reageren</span>
        </div>

        <template v-if="commentState == 0">
            <div class="comments__comments"
            :style="{ height: `${ commentsWrapHeight }px` }">
                <div v-for="(comment, i) in comments">
                    <Comment v-if="activeComments.indexOf(i) >= 0" :data="comment" />
                </div>
            </div>


            <!-- PAGINATION -->
            <div v-if="comments.length > commentsPerPage" class="comments__pagination">
                <div
                    @click="paginationPrev"
                    :class="{ 'disabled': activePage <= 0 }"
                    class="comments__pagination-btn comments__pagination-btn--prev">
                    <ArrowRight />
                </div>

                <div
                    v-for="(page, i) in pageNo"
                    :bind="'pagination'+ i"
                    @click="paginationN(i)"
                    :class="{ 'active': i == activePage }"
                    class="comments__pagination-btn comments__pagination-btn--number">
                    {{ i + 1 }}
                </div>
                <div
                    @click="paginationNext"
                    :class="{ 'disabled': activePage >= pageNo - 1 }"
                    class="comments__pagination-btn comments__pagination-btn--next">
                    <ArrowRight />
                </div>
            </div>

        </template>

        <template v-if="commentState == 1">
            <input class="comments__input-name" type="text" v-model="newName" :placeholder="texts.reactions_name_input">
            <textarea class="comments__input-comment" type="textarea" v-model="newComment" maxlength="400" :placeholder="texts.reactions_input" />
            <p class="comments__rules" >
                {{ texts.reactions_subtitle }}
                <a :href="texts.reactions_link" target="_blank">
                    {{ texts.reactions_link_title }}
                </a>
            </p>
            <span
                @click="postComment()"
                :class="{ 'active': newComment.length }"
                class="comments__submit btn-solid--yellow">
                {{ texts.reactions_send }}
            </span>
        </template>

        <div class="comments__confirmation" v-if="commentState == 2">
            <h5>
                {{ texts.reactions_thanks_title }}
            </h5>
            <p>
                {{ texts.reactions_thanks_text }}
            </p>
            <span @click="setCommentState(0)" class="btn-ghost--white mt-l mb-l">
                {{ texts.reactions_all }}
            </span>
        </div>

    </div>
</template>

<script>

import axios from 'axios';
import Comment from './Comment.vue';
import ArrowRight from './svg/ArrowRight.vue';

export default {

name: 'Comments',

data() {
    return {
        apiUrl: null,
        comments: [],
        // 0 = reading, 1 = adding comment, 2 = added comment
        commentState: 0,
        newName: '',
        newComment: '',
        activePage: 0,
        commentsPerPage: 3,
        commentsWrapHeight: 0,
        texts: {
            "reactions_main_title":"Reacties",
            "reactions_name_input":"Naam (optioneel)",
            "reactions_input":"Schrijf hier uw reactie",
            "reactions_subtitle":"Wilt u een reactie achterlaten? Lees dan hier de",
            "reactions_link":"#",
            "reactions_link_title":"spelregels",
            "reactions_send":"Reactie versturen",
            "reactions_thanks_title":"Bedankt voor uw reactie",
            "reactions_thanks_text":"Het kan even duren voordat uw reactie in het overzicht verschijnt. \nLorem ipsum dolor sit amet, consectetur adipisicing elit.",
            "reactions_all":"Naar alle reacties"
        }
    };
},

computed: {
    activeComments() {
        let results = []
        for (let i = 0; i < this.commentsPerPage; i++) {
            results.push(this.activePage * this.commentsPerPage + i);
        }
        return results;
    },
    pageNo() {
        return Math.ceil(this.comments.length / this.commentsPerPage);
    }
},

components: {
    Comment,
    ArrowRight
},

methods: {
    getComments() {
        axios.get(this.apiUrl).then(resp => {
            this.comments = resp.data.data;
            this.comments.length <= 0 && (this.commentState = 1);
            setTimeout(() => {
                this.adjustCommentsHeight();
            }, 300);
        });
    },
    writeComment() {
        this.commentState = 1;
    },
    postComment() {
        const $this = this;
        const data = {
            name: this.newName,
            comment: this.newComment
        }

        axios.post(this.apiUrl, data)
            .then(function (response) {
                console.log(response);
                $this.commentState = 2;
                $this.newName = "";
                $this.newComment = "";
            })
            .catch(function (error) {
                console.log(error);
            });
    },
    setCommentState(n) {
        this.commentState = n;
    },
    paginationPrev() {
        this.activePage--;
        this.adjustCommentsHeight();
    },
    paginationNext() {
        this.activePage++;
        this.adjustCommentsHeight();
    },
    paginationN(n) {
        this.activePage = n;
        this.adjustCommentsHeight();
    },
    adjustCommentsHeight() {
        setTimeout(() => {
            let commentWrap = document.querySelectorAll('.comments__comments');
            let comments = document.querySelectorAll('.comment');
            let height = 0;
            const margin = 24
            comments.forEach(comment => {  
                height += comment.offsetHeight + margin;
            })
            this.commentsWrapHeight = height
        }, 100);
    }
},

mounted() {
},

created() {
    const comments = document.querySelector('.js-comments-inner');
    const id = comments.getAttribute('page-id');
    const texts = JSON.parse(comments.getAttribute('texts'));
    for (let key in texts) {
        texts[key] && (this.texts[key] = texts[key]);
    }
    this.apiUrl = `/api/comment/${id}`;
    this.getComments();
}

};
</script>
